<template>
  <v-container fluid>
    <!-- file import and list -->
    <el-overlay-loading :loading="pageloading" />
    <template v-if="showImport || showList">
      <!-- title  -->
      <h1 class="mb-1">{{ $t(getTitle) }}</h1>
      <!-- form  -->
      <v-card outlined class="mb-4">
        <form @keydown.enter.prevent="submit()">
          <v-card-text>
            <v-row class="mb-0 pb-0">
              <v-col v-if="showImport" class="pb-0" cols="12" md="12">
                <p style="color: red">
                  <i>Keliamame faile gali būti užpildyta iki 500 eilučių!</i>
                </p>
                <el-file-input
                  label="Dokumentas"
                  v-model="file"
                  @addFile="addFile($event, 'file')"
                ></el-file-input>
              </v-col>
              <v-col>
                <!-- list -->
                <template v-if="showList">
                  <v-data-table
                    class="mb-4 custom-table sticky-header"
                    :loading="loading"
                    item-key="item_index"
                    :items-per-page="1000"
                    :headers="filteredHeader"
                    :items="formData"
                    :hide-default-footer="true"
                    :header-props="{
                      sortByText: $t('Rūšiuoti pagal'),
                    }"
                    :footer-props="{
                      showFirstLastPage: true,
                      showCurrentPage: true,
                      itemsPerPageText: $t('Rodyti po:'),
                      itemsPerPageAllText: $t('visi'),
                    }"
                  >
                    <!-- custom templates -->
                    <template v-slot:item="{ item, index }">
                      <el-table-service-row
                        @editItem="onEditItem"
                        :item="item"
                        :level="1"
                        fromImport
                        :key="`main_${index}`"
                        show
                      />
                    </template>
                    <!-- basic templates -->
                    <template slot="loading">
                      {{ $t('Kraunasi...') }}
                    </template>
                    <template slot="no-results">
                      {{ $t('Duomenų nėra') }}
                    </template>
                    <template slot="no-data">
                      {{ $t('Duomenų nėra') }}
                    </template>
                    <template #[`footer.page-text`]="props">
                      {{ $t('Rodoma') }} {{ props.pageStart }}-{{
                        props.pageStop
                      }}
                      {{ $t('iš') }}
                      {{ props.itemsLength }}
                    </template>
                  </v-data-table>
                </template>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <el-button
                class="mr-1"
                color="secondary"
                icon="atšaukti"
                title="Atšaukti"
                @click.native.stop="back()"
                :loading="loading"
              />
              <el-button
                v-if="!showImport"
                class="mr-1"
                color="secondary"
                title="Išeksportuoti "
                @click.native.stop="exportXls()"
                :loading="loading"
              />
              <el-button
                v-if="!showImport"
                class="mr-1"
                color="primary"
                title="Patvirtinti"
                @click.native.stop="saveData()"
                :loading="loading"
              />
            </v-row>
          </v-card-actions>
        </form>
      </v-card>
    </template>
    <!-- import modal -->
    <v-dialog
      v-model="showImportModal"
      persistent
      max-width="900px"
    >
      <el-overlay-loading :loading="loading" />
      <v-card class="modalCard">
        <v-card-title class="modalTitle pt-2 pb-1">
          <h3 style="word-break: break-word">{{ 'Paslaugos įkėlimas' }}</h3>
          <v-spacer></v-spacer>
          <v-btn icon @click.native.stop="closeImportModal()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="pb-4 pt-0" />
        <v-card-text style="text-align: center" class="pt-3 pb-2">
          <div class="import-modal-div">
          <template v-for="(item, index) in importModalData.errors" >
            <li :key="index"> {{ item }}</li>
          </template>
        </div>
        </v-card-text>
        <v-card-actions class="modalActions">
          <v-row style="text-align: right" no-gutters>
            <v-col>
              <el-button
                title="ATŠAUKTI IMPORTAVIMĄ"
                class="mb-2 mr-2"
                :loading="loading"
                @click.native.stop="closeImportModal()"
                color="secondary"
              />
              <el-button
                title="IMPORTUOTI TIK NESUTAMPANČIAS PASLAUGAS"
                class="mb-2 mr-2"
                :loading="loading"
                @click.native.stop="confirmImportModal('skip-duplicate')"
                color="primary"
              />
              <el-button
                title="TĘSTI IMPORTAVIMĄ"
                class="mb-2 mr-2"
                :loading="loading"
                @click.native.stop="confirmImportModal('with-duplicate')"
                color="primary"
              />
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- edit -->
    <template v-if="showEdit">
      <admin-service-form
        @save="editSave"
        @back="editBack"
        fromImport
        :importObject="editItem"
      />
    </template>
  </v-container>
</template>

<script>
import userRole from '@/mixins/userRole'
import AdminServiceForm from './AdminServiceForm'
import math from '@/mixins/math'

export default {
  name: 'AdminServiceImportForm',
  components: { AdminServiceForm },
  mixins: [userRole, math],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: false,
      showImportModal: false,
      importModalData: {},
      elementData: null,
      loading: false,
      formData: {},
      file: null,
      isEditing: false,
      editItem: {},
      mode: 'import',
    }
  },
  computed: {
    showImport() {
      return this.mode == 'import'
    },
    showList() {
      return this.mode == 'list'
    },
    showEdit() {
      return this.mode == 'edit'
    },
    modeReadonly() {
      return false
    },
    getTitle() {
      return this.$t(`Paslaugų įkėlimas`)
    },
    headers() {
      return [
        {
          text: '',
          align: 'right',
          sortable: false,
          value: '',
          width: '1%',
        },
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
          width: '8rem',
        },
        {
          text: this.$t('Paslaugos kodas'),
          align: 'start',
          value: 'code',
          width: '7rem',
        },
        {
          text: this.$t('Institucijos kodas'),
          align: 'start',
          value: 'institution_code',
          width: '7rem',
        },
        {
          text: this.$t('Institucijos pavadinimas'),
          align: 'start',
          value: 'institution_fullname',
          width: '9rem',
        },
        {
          text: this.$t('PASIS kodas'),
          align: 'start',
          value: 'pasis_code',
          width: '9rem',
        },
        {
          text: this.$t('Paslaugos pavadinimas (LT)'),
          align: 'start',
          value: 'title_lt',
          width: '20rem',
        },
        {
          text: this.$t('Paslaugos pavadinimas (EN)'),
          align: 'start',
          value: 'title_en',
          width: '20rem',
        },
        {
          text: this.$t('Paslaugos tipas'),
          align: 'start',
          value: 'type',
          width: '9rem',
        },
        {
          text: this.$t('El. paslauga'),
          align: 'start',
          value: 'digital_service',
          width: '8rem',
        },
        {
          text: this.$t('Tik notarinis'),
          align: 'start',
          value: 'notarial_only',
          width: '7.8rem',
        },
        {
          text: this.$t('Prokūra'),
          align: 'start',
          value: 'procuration_law',
          width: '6rem',
        },
        {
          text: this.$t('Aktyvumas'),
          align: 'start',
          value: 'is_active',
          width: '8rem',
        },
        {
          text: this.$t('Galioja nuo'),
          align: 'start',
          value: 'valid_from',
          width: '8rem',
        },
        {
          text: this.$t('Galioja iki'),
          align: 'start',
          value: 'valid_to',
          width: '7rem',
        },
        {
          text: this.$t('Įgaliojimo tipo kodas'),
          align: 'start',
          value: 'mandate_type_code',
          width: '7rem',
        },
      ]
    },

    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },
  },
  beforeDestroy() {},
  created() {},
  methods: {
    addFile(file, name) {
      this.addUploadedFiles(file, name)
    },
    addUploadedFiles(element, name) {
      if (element != null) {
        this.getData(element)
      }
    },
    presetIndex(items, index) {
      items.map((item, subIndex) => {
        let itemIndex = ''
        if (index) {
          itemIndex = `${index}_${subIndex}`
        } else {
          itemIndex = `${subIndex}`
        }
        item.item_index = itemIndex
        if (item.children) {
          this.presetIndex(item.children, itemIndex)
        }
      })
    },
    getData(element, type) {
      this.elementData = element
      this.loading = true
      this.pageloading = true
      let formData = new FormData()
      if(type){
        formData.append(`import_type`, type)
      }
      formData.append(`file`, element)
      let url = `actions/import`
      this.$axios
        .post(url, formData)
        .then((res) => {
          this.formData = res.data.actions
          this.presetIndex(this.formData)
          this.mode = 'list'
          this.isEditing = true
        })
        .catch((err) => {
          if(err.response.data.only_duplicate_errors){
            this.importModalData = err.response.data
            this.showImportModal = true
          } else {
            this.file = null
            this.$root.$emit('DATA_ERROR', err)
          }
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    closeImportModal(){
      this.importModalData =  {}
      this.showImportModal = false
      this.file = null
      this.elementData = null
    },
    confirmImportModal(type){
      const isSave =  this.importModalData.save
      const elementData = this.elementData
      this.closeImportModal()
      if(isSave){
        this.saveData(type)
      } else {
        this.getData(elementData, type)
      }
    },
    back() {
      this.$router.push({ name: 'classifierServices' })
    },
    preventNav(event) {
      if (!this.isEditing) return
      event.preventDefault()
      event.returnValue = ''
    },
    onEditItem(item) {
      this.mode = 'edit'
      this.editItem = item
    },
    editSave() {
      this.mode = 'list'
    },
    setDataByIndex(formData, data, indexList, level) {
      const index = formData.findIndex(
        (item) => item.item_index.split('_')[level] === indexList[level]
      )
      if (indexList.length == level + 1) {
        formData[index] = data
      } else {
        this.setDataByIndex(
          formData[index].children,
          data,
          indexList,
          level + 1
        )
      }
    },
    editBack(data) {
      let indexList = data.item_index.split('_')
      this.setDataByIndex(this.formData, data, indexList, 0)
      this.mode = 'list'
    },
    saveData(type) {
      this.loading = true
      let data = { actions: this.formData }
      if(type){
        data.import_type = type
      }
      this.$axios
        .post(`actions/save-import`, data)
        .then((res) => {
          this.isEditing = false
          this.$root.$emit('DATA_OK_CODE', '000110')
          this.back()
        })
        .catch((err) => {
          if(err.response.data.only_duplicate_errors){
            this.importModalData = err.response.data
            this.importModalData.save = true
            this.showImportModal = true
          } else {
            this.$root.$emit('DATA_ERROR', err)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    openFile(file) {
      var fileLink = document.createElement('a')
      fileLink.href = file.file
      fileLink.setAttribute(
        'download',
        this.safeFileName(file.original_filename)
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    exportXls() {
      this.loading = true
      this.$axios
        .post(`actions/export`, { actions: this.formData })
        .then((res) => {
          this.openFile(res.data)
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
  beforeMount() {
    window.addEventListener('beforeunload', this.preventNav)
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('beforeunload', this.preventNav)
    })
  },

  beforeRouteLeave(to, from, next) {
    if (this.isEditing) {
      if (!window.confirm('Pakeitimai nebus išsaugoti')) {
        return
      }
    }
    next()
  },
}
</script>
<style lang="scss" scoped>
.import-modal-div{
  border: 1px solid rgba(0, 0, 0, .12);
  border-radius: 5px;
  text-align: left;
  padding: 5px 5px 5px 15px;
  max-height: 300px;
  overflow-y: auto;
}
</style>
